/**
 * @generated SignedSource<<182458343d930cdefbf99ab330022b8f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "LandResponse",
    "kind": "LinkedField",
    "name": "landImpulse",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Land",
        "kind": "LinkedField",
        "name": "lands",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PickEx",
            "kind": "LinkedField",
            "name": "pickExs",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "index",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Solve",
        "kind": "LinkedField",
        "name": "solves",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "amount",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "serviceViewAmountLandImpulseQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "serviceViewAmountLandImpulseQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ab3b836e76ed782a428be45cbd5eba87",
    "id": null,
    "metadata": {},
    "name": "serviceViewAmountLandImpulseQuery",
    "operationKind": "query",
    "text": "query serviceViewAmountLandImpulseQuery(\n  $request: LandRequestInput\n) {\n  landImpulse(request: $request) {\n    lands {\n      pickExs {\n        index\n      }\n    }\n    solves {\n      amount\n    }\n  }\n}\n"
  }
};
})();

node.hash = "fd97bc1296403d1cdf6f5f7e19170afe";

module.exports = node;
